export default __webpack_public_path__ + "386cfc766bc14d0339a28639ec192ca7.png";